import { Injectable } from '@angular/core';
import { LocalStorageService } from '@library/utils/services/local-storage.service';

@Injectable()
export class CompareFirstUseSlidesService {

  constructor(
    private localStorage: LocalStorageService,
  ) {}

  registerCloseFirstUseSlides() {
    this.localStorage.setItem('control-fus-seen-compare', 'true');
  }

}
